import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

interface CustomTextFieldProps extends Omit<TextFieldProps, 'variant'> {
  isFullWidth?: boolean;
}

export const CustomTextField: React.FC<CustomTextFieldProps> = ({ 
  isFullWidth = false, 
  sx,
  ...props 
}) => {
  const baseStyles = {
    '& .MuiInputBase-root': {
      height: '40px',
      backgroundColor: '#3A3A3A',
    },
    '& .MuiInputBase-input': {
      color: '#fff',
      height: '40px',
      padding: '0 14px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#22c55e',
      borderWidth: '1px',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#22c55e',
      borderWidth: '1px',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#22c55e',
      borderWidth: '2px',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#22c55e',
      },
    },
  };

  const widthStyles = isFullWidth ? {
    width: '100%',
    '& .MuiInputBase-root': {
      width: '100%',
    }
  } : {
    flex: 1,
    maxWidth: '70%',
  };

  return (
    <TextField
      {...props}
      variant="outlined"
      sx={{
        ...baseStyles,
        ...widthStyles,
        ...sx,
      }}
    />
  );
};